module.exports = __webpack_public_path__ + "img/ons_campaign_3_desc.35fe0c28.png";